//TODO: Migrate Campaign Saga Here

import { all, put, select, takeEvery } from "redux-saga/effects";
import { get } from 'lodash';

import constants from '../../../../helpers/constant';

import { showToast } from '../notification';
import * as Actions from './actions';
import { loadCampaignsAPI, updatePermissionsAPI, refreshCampaignDataAPI } from '../../../../helpers/campaignApi';
import { updateCampaign } from '../campaign';

const VIEWER_ROLE = 'viewer';
const EDITOR_ROLE = 'editor';

function* refreshCampaignData(action) {
  const config = yield select(state => state.config);
  const { campaignId } = action.payload;
  const fetchResults = yield refreshCampaignDataAPI(config.urlApi, campaignId);

  if (fetchResults.error) {
    yield put(showToast({
      type: constants.FAILED,
      action: 'Dismiss',
      message: 'Something went wrong'
    }));
  }
  if (fetchResults && !fetchResults.error) {
    const refreshedCampaign = get(fetchResults, 'data', []);
    yield put(Actions.setCampaignNewHashWindow(refreshedCampaign.campaignId, refreshedCampaign.hashWindow));
  }
}

function* loadCampaigns(action) {
  const config = yield select(state => state.config);
  const campaignsById = yield select(state => state.campaign.byId);
  const { campaignIds, mustLoad } = action.payload;
  const campaignToProcess = [];
  for (let i = 0; i < campaignIds.length; i++) {
    const campaignId = campaignIds[i];
    const currentStatus = get(campaignsById, [campaignId, 'loadStatus']);
    if (currentStatus !== Actions.Status.LOADING && currentStatus !== Actions.Status.LOADED || mustLoad) {
      campaignToProcess.push(campaignId);
      yield put(updateCampaign({
        campaign_id: campaignId,
        loadStatus: Actions.Status.LOADING
      }))
    }
  }
  if (campaignToProcess.length === 0) {
    return;
  }

  const fetchResults = yield loadCampaignsAPI(config.urlApi, campaignToProcess);

  if (fetchResults && !fetchResults.error) {
    const loadedCampaigns = get(fetchResults, 'data', []);
    yield put(Actions.setCampaigns(loadedCampaigns, campaignToProcess));
  } else {
    yield put(Actions.setCampaigns([], campaignToProcess));
    yield put(showToast({
      type: constants.FAILED,
      action: 'Dismiss',
      message: 'Fail Loading Campaigns'
    }));
  }
}

function* updateCampaignPermissions(action) {
  const config = yield select(state => state.config);
  const { campaignId, permissions } = action.payload;
  const updateResults = yield updatePermissionsAPI(config.urlApi, campaignId, permissions);
  if (updateResults && !updateResults.error) {
    const { id:updatedCampaignId, users } = updateResults.data;
    
    //Group user permissions into 2 bucket (viewers & editors)
    const newPermissions = users.reduce((accumulator, entry) => {
      if (entry.role === VIEWER_ROLE) {
        accumulator.viewers.push(entry.id);
      } else if (entry.role === EDITOR_ROLE) {
        accumulator.editors.push(entry.id);
      }
      return accumulator;
    }, {viewers: [], editors: []});

    yield put(Actions.setCampaignPermissions(updatedCampaignId, newPermissions));
  } else {
    yield put(showToast({
      type: constants.FAILED,
      action: 'Dismiss',
      massage: 'Fail Updating Campaign Sharing'
    }));
  }
}

export default function* campaign() {
  const ActionType = Actions.ActionType;

  yield all([
    takeEvery(ActionType.LOAD_CAMPAIGNS, loadCampaigns),
    takeEvery(ActionType.UPDATE_CAMPAIGN_PERMISSIONS, updateCampaignPermissions),
    takeEvery(ActionType.REFRESH_CAMPAIGN_DATA, refreshCampaignData)
  ]);
};
